import React, { useEffect, useState } from "react";

const AnalyticsART: React.FC = () => {
  useEffect(() => {
    (window as any).Highcharts.chart("c4", {
      chart: {
        type: "line",
      },
      title: {
        text: "Average Response Time",
      },
      subtitle: {
        text: "Buyer: Tatenda Sibanda",
      },
      xAxis: {
        categories: [
          "Jan 24",
          "Feb 24",
          "Mar 24",
          "Apr 24",
          "May 24",
          "Jun 24",
          "Jul 24",
          "Aug 24",
          "Sep 24",
          "Oct 24",
          "Nov 24",
          "Dec 24",
        ],
        accessibility: {
          description: "Months of the year",
        },
      },
      yAxis: {
        title: {
          text: "Hours",
        },
        labels: {
          format: "{value}",
        },
      },
      tooltip: {
        crosshairs: true,
        shared: true,
      },
      plotOptions: {
        line: {
          marker: {
            radius: 1,
            lineColor: "#666666",
            lineWidth: 1,
          },
        },
      },
      series: [
        {
          name: "Response Time",
          marker: {
            symbol: "circle",
          },
          color: "red",
          data: [14, 17, 16, 16, 15, 13, 15, 12, 7, 5, 3, 5],
        },
      ],
    });
  }, []);

  return (
    <>
      <div className="card mb-5">
        <div className="collapse show">
          <div id="kt_account_signin_method" className="collapse show">
            <div className="card-body border-top p-9">
              <div className="c4" id="c4">
                Loading...
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export { AnalyticsART };
